function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Themepark = function Themepark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    d: "M22 9.27a.75.75 0 0 1 0 1.5q-.13 0-.25.007V22a.75.75 0 0 1-1.5 0V11.307a3 3 0 0 0-.436.422c-.552.644-.922 1.496-1.46 2.54-.302.587-.651 1.209-1.104 1.795V22a.75.75 0 0 1-1.5 0v-4.52c-.795.526-1.771.891-3 1.033V22a.75.75 0 0 1-1.5 0v-3.42h-3V22a.75.75 0 0 1-1.5 0v-3.42h-3V22a.75.75 0 0 1-1.5 0v-3.42H2a.75.75 0 0 1 0-1.5h9.56c1.768 0 2.877-.448 3.653-1.058.795-.627 1.314-1.48 1.807-2.44.468-.908.952-2.01 1.654-2.83.76-.886 1.79-1.481 3.326-1.481M9 1.58a7.75 7.75 0 0 1 0 15.5l-.398-.01A7.75 7.75 0 0 1 9 1.58M5.144 14.246a6.2 6.2 0 0 0 3.106 1.287v-4.392zm4.606 1.287a6.2 6.2 0 0 0 3.105-1.287L9.75 11.141zM2.797 10.08a6.2 6.2 0 0 0 1.286 3.105l3.106-3.105zm11.119 3.105a6.2 6.2 0 0 0 1.287-3.105h-4.392zM4.083 5.474A6.2 6.2 0 0 0 2.797 8.58h4.392zM10.81 8.58h4.393a6.2 6.2 0 0 0-1.287-3.106zM8.25 3.126a6.2 6.2 0 0 0-3.106 1.287L8.25 7.52zm1.5 4.394 3.105-3.107A6.2 6.2 0 0 0 9.75 3.126z"
  }));
};
export default Themepark;
Themepark.displayName = 'Themepark';